import { useState, FormEvent, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

// Google Ads Conversion Tracking Function
const trackConversion = () => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'conversion', {
      send_to: 'AW-17878625599/m8oPCPCe6fobEL_amM1C',
      value: 1.0,
      currency: 'USD',
    });
  }
};

const vehicleMakes: Record<string, string[]> = {
  Acura: ['ILX', 'Integra', 'MDX', 'RDX', 'TLX'],
  Audi: [
    'A3',
    'A4',
    'A5',
    'A6',
    'A7',
    'A8',
    'e-tron',
    'Q3',
    'Q5',
    'Q7',
    'Q8',
    'RS5',
    'RS7',
    'S4',
    'S5',
    'TT',
  ],
  BMW: [
    '2 Series',
    '3 Series',
    '4 Series',
    '5 Series',
    '7 Series',
    '8 Series',
    'i4',
    'iX',
    'M3',
    'M4',
    'M5',
    'X1',
    'X3',
    'X5',
    'X6',
    'X7',
    'Z4',
  ],
  Buick: ['Enclave', 'Encore', 'Encore GX', 'Envision'],
  Cadillac: ['CT4', 'CT5', 'Escalade', 'Lyriq', 'XT4', 'XT5', 'XT6'],
  Chevrolet: [
    'Blazer',
    'Bolt EV',
    'Camaro',
    'Colorado',
    'Corvette',
    'Equinox',
    'Malibu',
    'Silverado 1500',
    'Silverado 2500HD',
    'Suburban',
    'Tahoe',
    'Trailblazer',
    'Traverse',
    'Trax',
  ],
  Chrysler: ['300', 'Pacifica', 'Voyager'],
  Dodge: ['Challenger', 'Charger', 'Durango', 'Hornet'],
  Ford: [
    'Bronco',
    'Bronco Sport',
    'Edge',
    'Escape',
    'Expedition',
    'Explorer',
    'F-150',
    'F-250',
    'Maverick',
    'Mustang',
    'Mustang Mach-E',
    'Ranger',
  ],
  Genesis: ['G70', 'G80', 'G90', 'GV60', 'GV70', 'GV80'],
  GMC: [
    'Acadia',
    'Canyon',
    'Hummer EV',
    'Sierra 1500',
    'Sierra 2500HD',
    'Terrain',
    'Yukon',
  ],
  Honda: ['Accord', 'Civic', 'CR-V', 'HR-V', 'Odyssey', 'Passport', 'Pilot', 'Ridgeline'],
  Hyundai: [
    'Elantra',
    'Ioniq 5',
    'Ioniq 6',
    'Kona',
    'Palisade',
    'Santa Cruz',
    'Santa Fe',
    'Sonata',
    'Tucson',
    'Venue',
  ],
  Infiniti: ['Q50', 'Q60', 'QX50', 'QX55', 'QX60', 'QX80'],
  Jaguar: ['E-PACE', 'F-PACE', 'F-TYPE', 'I-PACE', 'XF'],
  Jeep: [
    'Cherokee',
    'Compass',
    'Gladiator',
    'Grand Cherokee',
    'Grand Cherokee L',
    'Renegade',
    'Wagoneer',
    'Wrangler',
  ],
  Kia: [
    'Carnival',
    'EV6',
    'EV9',
    'Forte',
    'K5',
    'Niro',
    'Seltos',
    'Sorento',
    'Soul',
    'Sportage',
    'Stinger',
    'Telluride',
  ],
  'Land Rover': [
    'Defender',
    'Discovery',
    'Discovery Sport',
    'Range Rover',
    'Range Rover Evoque',
    'Range Rover Sport',
    'Range Rover Velar',
  ],
  Lexus: ['ES', 'GX', 'IS', 'LC', 'LX', 'NX', 'RC', 'RX', 'RZ', 'TX', 'UX'],
  Lincoln: ['Aviator', 'Corsair', 'Nautilus', 'Navigator'],
  Mazda: ['CX-30', 'CX-5', 'CX-50', 'CX-90', 'Mazda3', 'MX-5 Miata', 'MX-30'],
  'Mercedes-Benz': [
    'A-Class',
    'C-Class',
    'CLA',
    'CLE',
    'E-Class',
    'EQB',
    'EQE',
    'EQS',
    'G-Class',
    'GLA',
    'GLB',
    'GLC',
    'GLE',
    'GLS',
    'S-Class',
    'SL',
  ],
  MINI: ['Clubman', 'Convertible', 'Countryman', 'Hardtop'],
  Mitsubishi: ['Eclipse Cross', 'Mirage', 'Outlander', 'Outlander Sport'],
  Nissan: [
    'Altima',
    'Ariya',
    'Frontier',
    'Kicks',
    'Leaf',
    'Maxima',
    'Murano',
    'Pathfinder',
    'Rogue',
    'Sentra',
    'Titan',
    'Versa',
    'Z',
  ],
  Porsche: ['718 Boxster', '718 Cayman', '911', 'Cayenne', 'Macan', 'Panamera', 'Taycan'],
  Ram: ['1500', '2500', '3500', 'ProMaster'],
  Rivian: ['R1S', 'R1T'],
  Subaru: [
    'Ascent',
    'BRZ',
    'Crosstrek',
    'Forester',
    'Impreza',
    'Legacy',
    'Outback',
    'Solterra',
    'WRX',
  ],
  Tesla: ['Model 3', 'Model S', 'Model X', 'Model Y', 'Cybertruck'],
  Toyota: [
    '4Runner',
    'bZ4X',
    'Camry',
    'Corolla',
    'Corolla Cross',
    'Crown',
    'GR86',
    'GR Supra',
    'Grand Highlander',
    'Highlander',
    'Prius',
    'RAV4',
    'Sequoia',
    'Sienna',
    'Tacoma',
    'Tundra',
    'Venza',
  ],
  Volkswagen: [
    'Atlas',
    'Atlas Cross Sport',
    'Golf GTI',
    'Golf R',
    'ID.4',
    'Jetta',
    'Taos',
    'Tiguan',
  ],
  Volvo: [
    'C40 Recharge',
    'S60',
    'S90',
    'V60',
    'V90',
    'XC40',
    'XC60',
    'XC90',
  ],
  Other: ['Other'],
};

const makesList = Object.keys(vehicleMakes).sort();

const US_STATES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export default function LeadForm() {
  const navigate = useNavigate();
  const [step, setStep] = useState<1 | 2 | 3>(1);
  const [formData, setFormData] = useState({
    pickupCity: '',
    pickupState: '',
    pickupZip: '',
    deliveryCity: '',
    deliveryState: '',
    deliveryZip: '',
    vehicleYear: '',
    vehicleMake: '',
    vehicleModel: '',
    transportDate: '',
    transportType: '',
    vehicleCondition: '',
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const modelsList = useMemo(() => {
    if (!formData.vehicleMake) return [];
    return vehicleMakes[formData.vehicleMake] || [];
  }, [formData.vehicleMake]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    if (name === 'vehicleMake') {
      setFormData((prev) => ({
        ...prev,
        vehicleMake: value,
        vehicleModel: '',
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const scrollToQuote = () => {
    const target = document.getElementById('quote');
    if (target) window.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
  };

  const handleStep1Next = (e: FormEvent) => {
    e.preventDefault();
    setStep(2);
    scrollToQuote();
  };

  const handleStep2Next = (e: FormEvent) => {
    e.preventDefault();
    setStep(3);
    scrollToQuote();
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams({
        pickupCity: formData.pickupCity,
        pickupState: formData.pickupState,
        pickupZip: formData.pickupZip,
        deliveryCity: formData.deliveryCity,
        deliveryState: formData.deliveryState,
        deliveryZip: formData.deliveryZip,
        vehicleYear: formData.vehicleYear,
        vehicleMake: formData.vehicleMake,
        vehicleModel: formData.vehicleModel,
        transportDate: formData.transportDate,
        transportType: formData.transportType,
        vehicleCondition: formData.vehicleCondition,
        firstName: formData.firstName,
        lastName: formData.lastName,
        phone: formData.phone,
        email: formData.email,
      }).toString();

      const [response] = await Promise.all([
        fetch('https://readdy.ai/api/form/d6e5cr6qd308q1a0adp0', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: formBody,
        }),
        fetch('https://readdy.ai/api/form/d6e76v3v53dtlm7j9100', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: formBody,
        }),
      ]);

      if (response.ok) {
        trackConversion();
        navigate('/thank-you');
        setSubmitStatus('success');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 2027 - 1901 + 1 }, (_, i) => 2027 - i);

  const transportOptions = [
    {
      value: 'Open Transport',
      description:
        'Most affordable option — your vehicle is exposed to weather but fully insured',
    },
    {
      value: 'Enclosed Transport',
      description:
        'Premium protection — fully covered trailer shields from weather and road debris',
    },
  ];

  const conditionOptions = [
    {
      value: 'Running',
      label: 'Running',
      icon: 'ri-checkbox-circle-line',
      description:
        'Vehicle starts, drives, steers, and brakes normally — standard transport rates apply',
    },
    {
      value: 'Non-Running',
      label: 'Non-Running',
      icon: 'ri-error-warning-line',
      description:
        'Vehicle cannot start, steer, or brake on its own — requires winch or forklift loading (additional fee may apply)',
    },
  ];

  const steps = [
    { label: 'Vehicle & Transport' },
    { label: 'Locations' },
    { label: 'Your Information' },
  ];

  return (
    <section id="quote" className="py-24 bg-gray-900">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-white rounded-2xl shadow-2xl p-12">
          <h2 className="text-5xl font-bold text-gray-900 text-center mb-4">
            Get Your Free Quote in 60 Seconds
          </h2>
          <p className="text-xl text-gray-600 text-center mb-8">
            No credit card required. Instant pricing.
          </p>

          {/* Step Indicator */}
          <div className="flex items-center justify-center mb-10">
            {steps.map((s, idx) => {
              const num = idx + 1;
              const isCompleted = step > num;
              const isActive = step === num;
              return (
                <div key={num} className="flex items-center">
                  <div className="flex items-center gap-2">
                    <div
                      className={`w-9 h-9 rounded-full flex items-center justify-center font-bold text-sm transition-colors ${
                        isActive
                          ? 'bg-orange-600 text-white'
                          : isCompleted
                          ? 'bg-orange-100 text-orange-600'
                          : 'bg-gray-100 text-gray-400'
                      }`}
                    >
                      {isCompleted ? <i className="ri-check-line text-base"></i> : num}
                    </div>
                    <span
                      className={`text-sm font-semibold whitespace-nowrap ${
                        isActive ? 'text-orange-600' : isCompleted ? 'text-orange-400' : 'text-gray-400'
                      }`}
                    >
                      {s.label}
                    </span>
                  </div>
                  {idx < steps.length - 1 && (
                    <div className="w-12 h-0.5 bg-gray-200 mx-3 flex-shrink-0">
                      <div
                        className={`h-full bg-orange-500 transition-all duration-500 ${
                          step > num ? 'w-full' : 'w-0'
                        }`}
                      ></div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Step 1: Vehicle & Transport */}
          {step === 1 && (
            <form onSubmit={handleStep1Next} data-readdy-form id="auto-transport-form">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Vehicle Year</label>
                  <div className="relative">
                    <i className="ri-calendar-2-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                    <select name="vehicleYear" value={formData.vehicleYear} onChange={handleChange} required
                      className="w-full pl-12 pr-4 py-3.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base appearance-none cursor-pointer">
                      <option value="">Select Year</option>
                      {years.map((year) => <option key={year} value={year}>{year}</option>)}
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Vehicle Make</label>
                  <div className="relative">
                    <i className="ri-car-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                    <select name="vehicleMake" value={formData.vehicleMake} onChange={handleChange} required
                      className="w-full pl-12 pr-4 py-3.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base appearance-none cursor-pointer">
                      <option value="">Select Make</option>
                      {makesList.map((make) => <option key={make} value={make}>{make}</option>)}
                    </select>
                  </div>
                </div>

                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Vehicle Model</label>
                  <div className="relative">
                    <i className="ri-roadster-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                    <select name="vehicleModel" value={formData.vehicleModel} onChange={handleChange} required
                      disabled={!formData.vehicleMake}
                      className={`w-full pl-12 pr-4 py-3.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base appearance-none cursor-pointer ${
                        !formData.vehicleMake ? 'bg-gray-50 text-gray-400 cursor-not-allowed' : ''
                      }`}
                    >
                      <option value="">
                        {formData.vehicleMake ? 'Select Model' : 'Select a make first'}
                      </option>
                      {modelsList.map((model) => (
                        <option key={model} value={model}>
                          {model}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Transport Date</label>
                  <div className="relative">
                    <i className="ri-calendar-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                    <input type="date" name="transportDate" value={formData.transportDate} onChange={handleChange} required
                      className="w-full pl-12 pr-4 py-3.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base cursor-pointer" />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Transport Type</label>
                  <div className="relative">
                    <i className="ri-truck-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg z-10"></i>
                    <select name="transportType" value={formData.transportType} onChange={handleChange} required
                      className="w-full pl-12 pr-4 py-3.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base appearance-none cursor-pointer">
                      <option value="">Select Type</option>
                      <option value="Open Transport">Open Transport</option>
                      <option value="Enclosed Transport">Enclosed Transport</option>
                    </select>
                  </div>
                  {formData.transportType && (
                    <div className="mt-3 p-4 bg-orange-50 border border-orange-200 rounded-lg">
                      <div className="flex items-start gap-3">
                        <i className="ri-information-line text-orange-600 text-lg mt-0.5"></i>
                        <p className="text-sm text-gray-700">
                          {transportOptions.find((opt) => opt.value === formData.transportType)?.description}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-3">Vehicle Condition</label>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {conditionOptions.map((option) => (
                      <label key={option.value}
                        className={`relative flex items-start gap-4 p-4 border-2 rounded-xl cursor-pointer transition-all ${
                          formData.vehicleCondition === option.value
                            ? 'border-orange-500 bg-orange-50 shadow-sm'
                            : 'border-gray-200 hover:border-gray-300 bg-white'
                        }`}>
                        <input
                          type="radio"
                          name="vehicleCondition"
                          value={option.value}
                          checked={formData.vehicleCondition === option.value}
                          onChange={handleChange}
                          required
                          className="sr-only"
                        />
                        <div
                          className={`w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0 ${
                            formData.vehicleCondition === option.value
                              ? 'bg-orange-500 text-white'
                              : 'bg-gray-100 text-gray-500'
                          }`}
                        >
                          <i className={`${option.icon} text-xl`}></i>
                        </div>
                        <div className="flex-1">
                          <span
                            className={`block font-semibold text-base ${
                              formData.vehicleCondition === option.value
                                ? 'text-orange-700'
                                : 'text-gray-900'
                            }`}
                          >
                            {option.label}
                          </span>
                          <span className="block text-sm text-gray-500 mt-1 leading-relaxed">
                            {option.description}
                          </span>
                        </div>
                        <div
                          className={`w-5 h-5 flex items-center justify-center rounded-full border-2 flex-shrink-0 mt-0.5 ${
                            formData.vehicleCondition === option.value
                              ? 'border-orange-500 bg-orange-500'
                              : 'border-gray-300'
                          }`}
                        >
                          {formData.vehicleCondition === option.value && (
                            <i className="ri-check-line text-white text-xs"></i>
                          )}
                        </div>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              <button
                type="submit"
                className="w-full bg-orange-600 text-white py-4 rounded-lg text-lg font-bold hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Continue to Locations →
              </button>
            </form>
          )}

          {/* Step 2: Pickup & Delivery Locations */}
          {step === 2 && (
            <form onSubmit={handleStep2Next} data-readdy-form id="auto-transport-locations-form">
              {/* Pickup Location */}
              <div className="mb-8">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-9 h-9 flex items-center justify-center bg-orange-100 rounded-full">
                    <i className="ri-map-pin-line text-orange-600 text-lg"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">Pickup Location</h3>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">City</label>
                    <div className="relative">
                      <i className="ri-building-2-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                      <input type="text" name="pickupCity" value={formData.pickupCity} onChange={handleChange}
                        placeholder="Los Angeles" required
                        className="w-full pl-12 pr-4 py-3.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">State</label>
                    <div className="relative">
                      <i className="ri-map-2-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                      <select name="pickupState" value={formData.pickupState} onChange={handleChange} required
                        className="w-full pl-12 pr-4 py-3.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base appearance-none cursor-pointer">
                        <option value="">Select State</option>
                        {US_STATES.map((s) => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">ZIP Code</label>
                    <div className="relative">
                      <i className="ri-map-pin-2-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                      <input type="text" name="pickupZip" value={formData.pickupZip} onChange={handleChange}
                        placeholder="90001" required maxLength={10} pattern="[0-9]{5}(-[0-9]{4})?"
                        className="w-full pl-12 pr-4 py-3.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Divider */}
              <div className="flex items-center gap-4 mb-8">
                <div className="flex-1 h-px bg-gray-200"></div>
                <div className="w-9 h-9 flex items-center justify-center bg-gray-100 rounded-full flex-shrink-0">
                  <i className="ri-arrow-down-line text-gray-500 text-lg"></i>
                </div>
                <div className="flex-1 h-px bg-gray-200"></div>
              </div>

              {/* Delivery Location */}
              <div className="mb-8">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-9 h-9 flex items-center justify-center bg-green-100 rounded-full">
                    <i className="ri-map-pin-line text-green-600 text-lg"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">Delivery Location</h3>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">City</label>
                    <div className="relative">
                      <i className="ri-building-2-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                      <input type="text" name="deliveryCity" value={formData.deliveryCity} onChange={handleChange}
                        placeholder="New York" required
                        className="w-full pl-12 pr-4 py-3.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">State</label>
                    <div className="relative">
                      <i className="ri-map-2-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                      <select name="deliveryState" value={formData.deliveryState} onChange={handleChange} required
                        className="w-full pl-12 pr-4 py-3.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base appearance-none cursor-pointer">
                        <option value="">Select State</option>
                        {US_STATES.map((s) => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">ZIP Code</label>
                    <div className="relative">
                      <i className="ri-map-pin-2-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                      <input type="text" name="deliveryZip" value={formData.deliveryZip} onChange={handleChange}
                        placeholder="10001" required maxLength={10} pattern="[0-9]{5}(-[0-9]{4})?"
                        className="w-full pl-12 pr-4 py-3.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex gap-4">
                <button type="button" onClick={() => { setStep(1); scrollToQuote(); }}
                  className="w-1/3 bg-gray-100 text-gray-700 py-4 rounded-lg text-base font-semibold hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer">
                  ← Back
                </button>
                <button type="submit"
                  className="w-2/3 bg-orange-600 text-white py-4 rounded-lg text-lg font-bold hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer">
                  Continue to Contact Info →
                </button>
              </div>
            </form>
          )}

          {/* Step 3: Contact Information */}
          {step === 3 && (
            <form onSubmit={handleSubmit} data-readdy-form id="auto-transport-contact-form">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">First Name</label>
                  <div className="relative">
                    <i className="ri-user-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                    <input type="text" name="firstName" value={formData.firstName} onChange={handleChange}
                      placeholder="John" required
                      className="w-full pl-12 pr-4 py-3.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base" />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Last Name</label>
                  <div className="relative">
                    <i className="ri-user-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                    <input type="text" name="lastName" value={formData.lastName} onChange={handleChange}
                      placeholder="Smith" required
                      className="w-full pl-12 pr-4 py-3.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base" />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
                  <div className="relative">
                    <i className="ri-phone-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange}
                      placeholder="(555) 123-4567" required
                      className="w-full pl-12 pr-4 py-3.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base" />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
                  <div className="relative">
                    <i className="ri-mail-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                    <input type="email" name="email" value={formData.email} onChange={handleChange}
                      placeholder="your@email.com" required
                      className="w-full pl-12 pr-4 py-3.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base" />
                  </div>
                </div>
              </div>

              <div className="flex gap-4">
                <button type="button" onClick={() => { setStep(2); scrollToQuote(); }}
                  className="w-1/3 bg-gray-100 text-gray-700 py-4 rounded-lg text-base font-semibold hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer">
                  ← Back
                </button>
                <button type="submit" disabled={isSubmitting}
                  className="w-2/3 bg-orange-600 text-white py-4 rounded-lg text-lg font-bold hover:bg-orange-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer">
                  {isSubmitting ? 'Submitting...' : 'Get Instant Quote →'}
                </button>
              </div>

              {submitStatus === 'error' && (
                <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-800 text-center">
                  <i className="ri-error-warning-line mr-2"></i>
                  Something went wrong. Please try again or call us directly.
                </div>
              )}
            </form>
          )}

          <p className="text-center text-sm text-gray-500 mt-6">
            <i className="ri-lock-line mr-1"></i>
            Your information is secure and never shared
          </p>
        </div>
      </div>
    </section>
  );
}
